import React, { useState, useEffect, FC } from "react";
import { Link, useLocation } from "react-router-dom";
import { Icon, UserAvatar } from "../../components/Component"; // Assuming these are properly typed elsewhere
import {
  DropdownItem,
  UncontrolledDropdown,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";

interface BOQAsideProps {
  updateSm: (value: boolean) => void; // Function to update state
  sm: boolean; // Boolean state
}

const BOQAside: FC<BOQAsideProps> = ({ updateSm, sm }) => {
  const location = useLocation();
  const { data: allowedRoutes }: any = useSelector(
    (state: RootState) => state.allowedRoutes
  );
  useEffect(() => {
    sm
      ? document.body.classList.add("toggle-shown")
      : document.body.classList.remove("toggle-shown");
  }, [sm]);

  const isActive = (path: string): string => {
    return location.pathname === path ? "active" : "";
  };

  const LinkTo = ({ path }: { path: string }) => {
    if (!allowedRoutes.includes(path)) {
      return null;
    }
    switch (path) {
      case "create-consumption-target":
        return (
          <Link
            to={"/create-consumption-target"}
            className={isActive(
              `${process.env.PUBLIC_URL}/create-consumption-target`
            )}
          >
            <Icon name="plus-fill-c" />
            <span>Create</span>
          </Link>
        );
      case "consumption-target-list":
        return (
          <Link
            to={"/consumption-target-list"}
            className={isActive(
              `${process.env.PUBLIC_URL}/consumption-target-list`
            )}
          >
            <Icon name="eye-fill" />
            <span>List</span>
          </Link>
        );
      // case "consumption-target-Report":
      //   return (
      //     <Link
      //       to="/consumption-target-Report"
      //       className={isActive(
      //         `${process.env.PUBLIC_URL}/consumption-target-Report`
      //       )}
      //     >
      //       <Icon name="check-fill-c"  />
      //       <span>Report</span>
      //     </Link>
      //   );
      default:
        return null;
    }
  };

  return (
    <div className="card-inner-group">
      <div className="card-inner">
        <div className="user-account-info py-0">
          <h6 className="overline-title-alt" style={{ fontSize: 14 }}>
            BOQ
          </h6>
        </div>
      </div>
      <div className="card-inner p-0">
        <ul className="link-list-menu">
          {[
            "create-consumption-target",
            "consumption-target-list",
            // "consumption-target-Report",
          ].map((item) => (
            <li key={item} onClick={() => updateSm(false)}>
              <LinkTo path={item} />
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default BOQAside;
